'use client'
import type { LoyaltyVoucherCardProps } from '@maestro/commerce-blocks/loyalty/components/loyalty-voucher-card/loyalty-voucher-card.types'

import classNames from 'classnames'

import { useLoyaltyVoucherCard } from '@maestro/commerce-blocks/loyalty/components/loyalty-voucher-card/batons/use-loyalty-voucher-card'

import '@maestro/commerce-blocks/loyalty/components/loyalty-voucher-card/styles/loyalty-voucher-card.scss'

export default function LoyaltyVoucherCard(props: LoyaltyVoucherCardProps) {
  const { voucher, isSelectionEnabled } = props
  const { loyaltyVoucherName, loyaltyVoucherValue, loyaltyVoucherExpiresIn } =
    useLoyaltyVoucherCard(props)

  return (
    <div
      className={classNames('loyalty-voucher-card', {
        'loyalty-voucher-card--selectable': isSelectionEnabled,
      })}
    >
      <div className="loyalty-voucher-card__name">{loyaltyVoucherName}</div>
      <div className="loyalty-voucher-card__value">{loyaltyVoucherValue}</div>
      <div
        className="loyalty-voucher-card__details"
        dangerouslySetInnerHTML={{ __html: voucher.description }}
      />
      <div className="loyalty-voucher-card__expiry">
        {loyaltyVoucherExpiresIn}
      </div>
    </div>
  )
}
